import ShopaholicProductList from '@lovata/shopaholic-product-list/shopaholic-product-list';
import ShopaholicPagination from '@lovata/shopaholic-product-list/shopaholic-pagination';
import Swal from 'sweetalert2';
import LazyLoad from '../../../js/lazy-load';
import Lightbox from '../../common/lightbox/lightbox';


export default new class Crud {
  constructor() {
    this.btnRemoveItem = 'list-item__remove';
    this.sCatalogWrapper = 'list-wrapper';
    this.preLoaderSelector = 'catalog__preloader';

    this.init();
    this.handlers();
  }

  init() {
    this.clickHandler();
  }

  handlers() {
    if (!document.querySelector(`.${this.sCatalogWrapper}`)) return;

    this.initFilterHandlers();

    document.addEventListener('DOMContentLoaded', () => {
      this.chooseAjaxHelper();
    });

    document.addEventListener('onFormSuccess', () => {
      const obListHelper = this.updateAllAjax(false);
      obListHelper.send();
    });
  }

  chooseAjaxHelper() {
    this.obListHelper = this.updateAllAjax();
  }

  clickHandler() {
    document.addEventListener('click', (e) => {
      if (!e.target.matches(`.${this.btnRemoveItem}`)) return;

      const that = this;

      Swal.fire({
        title: 'Вы уверены, что хотите удалить запись?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.isConfirmed) {
          const data = {
            hash: e.target.dataset.hash,
            id: $(e.target.parentNode).attr('data-item'),
          };

          $.request('CrudItems::onRemove', {
            data,
            success(response) {
              this.success(response);

              $(`.list-item[data-item="${response.id}"]`).fadeOut();

              const obListHelper = that.updateAllAjax(false);
              obListHelper.send();
            },
          });
        }
      });
    });
  }

  updateAllAjax(bWithScroll = true) {
    const obListHelper = new ShopaholicProductList();

    obListHelper.setAjaxRequestCallback((obRequestData) => {
      /* eslint-disable  no-param-reassign */
      obRequestData.update = {
        'content/crud-items/list-ajax': `.${this.sCatalogWrapper}`,
      };
      obRequestData.complete = () => {
        LazyLoad.update();
        Lightbox.init();

        if (!this.checkWindowPosition() && bWithScroll) {
          const bar = $(`.${this.sCatalogWrapper}`);

          if (!bar.length) return;

          const distance = bar.offset().top;

          $('body, html').animate({ scrollTop: distance }, 350);
        }
      };
      obRequestData.loading = `.${this.preLoaderSelector}`;
      /* eslint-enable */

      return obRequestData;
    });

    return obListHelper;
  }

  initFilterHandlers() {
    const obListHelper = this.updateAllAjax();

    const obPaginationHelper = new ShopaholicPagination(obListHelper);
    obPaginationHelper.init();
  }

  checkWindowPosition() {
    const docViewTop = $(window).scrollTop();
    const docViewBottom = docViewTop + $(window).height();
    const bar = $(`.${this.sCatalogWrapper}`);

    if (!bar.length) return true;

    const elemTop = $(`.${this.sCatalogWrapper}`).offset().top;
    const elemBottom = elemTop + $(`.${this.sCatalogWrapper}`).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }
}();
